__webpack_require__.p = "https://gamma.in.safer.whs.amazon.dev/";